const appConstants = {
    BASE_URL: process.env.REACT_APP_NODE_ENV === "Production"? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL_LOCAL,
}

export default appConstants;
